import { Map } from 'immutable'
import { fromJS } from 'immutable'

/**
 *
 * @param {*} elemUID - could be string state path separated by ':', or string param as uid, or string param as 'param:uid'
 * @param {*} retState
 * @returns
 */

export const collectFieldGroupForStore = (elemUID, retState) => {
  //instead of having uid='param:uid', you have just 'uid'
  let uid = String(elemUID).split(':')
  let data
  if (uid?.length === 1) {
    //possible param
    const paramValue = retState.getIn(['params', uid[0]])
    if (paramValue) {
      //param found
      data = retState.getIn(['params', uid[0]])
      uid = ['params', uid[0]]
    }
  } else if (uid[0] === 'param') {
    //this will probably never happen, but it should since uid value should be  uid='param:uid'
    const paramValue = retState.getIn(['params', uid[1]])
    if (paramValue) {
      //param found
      data = retState.getIn(['params', uid[1]])
      uid = [elemUID]
    }
  } else {
    //not a param
    data = retState.getIn(['state', ...uid], Map())
  }
  return { data, path: uid }
}

/**
 *
 * @param {*} entry - {data:some value,path:path array for state or path array for params}
 * @description - eg. in case of state - {data:some value, path: ['p2','e8']}
 * @description -  eg. in case of param - {data:some value, path: ['params',uid]}
 * @param {*} retState
 * @returns
 */
export const collectFieldGroupForRestore = (entry, retState, changes) => {
  if (entry.path[0] === 'params') {
    retState = retState.setIn(entry.path, fromJS(entry.data))
  } else {
    retState = retState.setIn(['state', ...entry.path], fromJS(entry.data))
  }
  if (changes) {
    if (entry.path[0] === 'params') {
      changes.push(_.tail(entry.path))
    } else {
      changes.push(entry.path)
    }
  }
  return retState
}

/**
 *
 * @param {*} uid is a path array eg. ['e2','p2] or [some-uuid-param] or ['param:some-uuid-param']
 * @param {*} state
 * @returns
 */
export const collectFieldForStore = (uid, state) => {
  //instead of having uid='param:uid', you have just 'uid'
  let data
  if (uid?.length === 1) {
    //possible param
    const paramValue = state.getIn(['params', uid[0]])
    if (paramValue) {
      //param found
      data = state.getIn(['params', uid[0]])
      uid = ['params', uid[0]]
    }
  } else {
    let uidSplit = String(uid).split(':')
    if (uidSplit[0] === 'param') {
      //this will probably never happen, but it should since uid value should be  uid='param:uid'
      const paramValue = state.getIn(['params', uidSplit[1]])
      if (paramValue) {
        //param found
        data = state.getIn(['params', uidSplit[1]])
        uid = [elemUID]
      }
    } else {
      //not a param
      data = state.getIn(['state', ...uid], Map())
    }
  }
  return { data, path: uid }
}

/**
 *
 * @param {*} entry - value to set in state eg. {p2:{e8:some value}} or in param eg. {params:{uid:some value}}
 * @param {*} elemUID - path array for state eg. ['p2','e8'] for param eg. [uid]
 * @param {*} retState
 * @returns
 */
export const collectFieldForRestore = (entry, elemUID, retState, changes) => {
  if (entry.params) {
    let storeParams = retState.getIn(['params'], Map()).toJS()
    storeParams = { ...storeParams, ...entry.params }
    retState = retState.setIn(['params'], fromJS(storeParams))
    if (changes) {
      _.each(entry.params, (value, uid) => {
        changes.push([uid])
      })
    }
  } else {
    retState = retState.setIn(['state', ...elemUID], fromJS(_.get(entry, elemUID)))
    if (changes) {
      changes.push(elemUID)
    }
  }
  return retState
}
